module.exports = __webpack_public_path__ + "static/media/muna_kaki_talking_01.4c56b7f1.png";